import styled from 'styled-components';

const Button = styled.button`
  border-radius: 5px;
  width: ${({ width }) => width || '100%'};
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  height: ${({ height }) => height || '44px'};
  color: ${({ color }) => color || '#FFF'};
  font-size: ${({ fontSize }) => fontSize || '15px'};
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-top: 3px;
  background-color: ${({ backgroundColor }) => backgroundColor || '#000'};
  ${({ margin }) => `margin: ${margin};` || null}
  disabled: ${({ disabled }) => disabled}
`;

export default Button;
